import React from "react";

const LocationMap = () => {
  return (
    <div>
      <div>
        <iframe
          title="invest-trust limited"
          style={{ width: "100%", height: "483px" }}
          src="https://maps.google.com/maps?q=7a,%20Babatunde%20Jose%20street,%20off%20Ademola%20Adetokunbo%20Street%20Victoria%20Island,%20Lagos&t=&z=13&ie=UTF8&iwloc=&output=embed"
          frameborder="0"
          scrolling="no"
        ></iframe>
      </div>
    </div>
  );
};

export default LocationMap;
